export const getDisplayName = (info: any) => {
  if (info.fullname) {
    return info.fullname;
  }
  if (info.first_name) {
    return `${info.first_name} ${info.last_name}`;
  }
  return info.company_name;
};
